export default __webpack_public_path__ + "static/media/i_topport_light.48f2f265.svg";